// date input component

import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { MONTHS } from 'constants/constants';

import styled from 'styled-components';
import { Row, Col, Text } from '@cuemath/comps';

const Select = styled.select`
  width: 100%;
  height: 40px;
  font-size: 14px;
  background-color: ${({
    theme: {
      COLORS: { WHITE },
    },
  }) => WHITE};
  border-radius: 3px;
  border: 0.5px solid;
  padding: 5px 8px;
  border-color: ${({
    error,
    theme: {
      COLORS: { RED, PERIWINKLE_GRAY_DARK },
    },
  }) => (error ? RED : PERIWINKLE_GRAY_DARK)};
`;
const CustomRow = styled(Row)`
  & > :first-child {
    padding-left: 0;
  }
  & > :last-child {
    padding-right: 0;
  }
`;

export default class DateInput extends PureComponent {
  static isValid(value) {
    const [year = null, month = null, day = null] = value.split('-');

    return year && month && day;
  }

  static propTypes = {
    selected: PropTypes.string,
    label: PropTypes.string,
    onChange: PropTypes.func,
    startYear: PropTypes.string,
    noOfYearOptions: PropTypes.string,
  };

  static defaultProps = {
    label: null,
    selected: '',
    onChange: () => {},
    startYear: 1950,
    noOfYearOptions: 75,
  };

  constructor(props) {
    super(props);

    this.day = React.createRef();
    this.month = React.createRef();
    this.year = React.createRef();
  }

  onChange = () => {
    const { onChange } = this.props;

    if (onChange) {
      const day = this.day.current.value;
      const month = this.month.current.value;
      const year = this.year.current.value;

      onChange(`${year}-${month}-${day}`);
    }
  };

  render() {
    const { label, selected, startYear, noOfYearOptions } = this.props;
    const [year = '', month = '', day = ''] = selected.split('-');
    const startDateYear = parseInt(startYear, 10);

    return (
      <Fragment>
        <Text>{label}</Text>
        <CustomRow>
          <Col auto>
            <div className="select-container">
              <Select ref={this.day} value={day} onChange={this.onChange} id="day">
                <option disabled key={-1} value="">
                  Day
                </option>
                {Array.from(Array(31).keys()).map(id => (
                  <option key={id + 1} value={`0${id + 1}`.slice(-2)}>
                    {id + 1}
                  </option>
                ))}
              </Select>
            </div>
          </Col>
          <Col auto>
            <div className="select-container">
              <Select ref={this.month} value={month} onChange={this.onChange} id="month">
                <option disabled key={-1} value="">
                  Month
                </option>
                {MONTHS.map((item, index) => (
                  <option key={item} value={`0${index + 1}`.slice(-2)}>
                    {item}
                  </option>
                ))}
              </Select>
            </div>
          </Col>
          <Col auto>
            <div className="select-container">
              <Select ref={this.year} value={year} onChange={this.onChange} id="year">
                <option disabled key={-1} value="">
                  Year
                </option>
                {Array.from(Array(noOfYearOptions).keys()).map(id => (
                  <option key={id + startDateYear} value={id + startDateYear}>
                    {id + startDateYear}
                  </option>
                ))}
              </Select>
            </div>
          </Col>
        </CustomRow>
      </Fragment>
    );
  }
}
